export default () => ({
  translations: (window.AppData || {}).translations || {},
  locale: (window.AppData || {}).locale || '',
});
